"use strict";

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shrinkInteger = void 0;

var NextValue_1 = require("../../../check/arbitrary/definition/NextValue");

var Stream_1 = require("../../../stream/Stream");

function halvePosInteger(n) {
  return Math.floor(n / 2);
}

function halveNegInteger(n) {
  return Math.ceil(n / 2);
}

function shrinkInteger(current, target, tryTargetAsap) {
  var _marked = /*#__PURE__*/_regeneratorRuntime.mark(shrinkDecr),
      _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(shrinkIncr);

  var realGap = current - target;

  function shrinkDecr() {
    var previous, gap, toremove, next;
    return _regeneratorRuntime.wrap(function shrinkDecr$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            previous = tryTargetAsap ? undefined : target;
            gap = tryTargetAsap ? realGap : halvePosInteger(realGap);
            toremove = gap;

          case 3:
            if (!(toremove > 0)) {
              _context.next = 11;
              break;
            }

            next = toremove === realGap ? target : current - toremove;
            _context.next = 7;
            return new NextValue_1.NextValue(next, previous);

          case 7:
            previous = next;

          case 8:
            toremove = halvePosInteger(toremove);
            _context.next = 3;
            break;

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _marked);
  }

  function shrinkIncr() {
    var previous, gap, toremove, next;
    return _regeneratorRuntime.wrap(function shrinkIncr$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            previous = tryTargetAsap ? undefined : target;
            gap = tryTargetAsap ? realGap : halveNegInteger(realGap);
            toremove = gap;

          case 3:
            if (!(toremove < 0)) {
              _context2.next = 11;
              break;
            }

            next = toremove === realGap ? target : current - toremove;
            _context2.next = 7;
            return new NextValue_1.NextValue(next, previous);

          case 7:
            previous = next;

          case 8:
            toremove = halveNegInteger(toremove);
            _context2.next = 3;
            break;

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _marked2);
  }

  return realGap > 0 ? (0, Stream_1.stream)(shrinkDecr()) : (0, Stream_1.stream)(shrinkIncr());
}

exports.shrinkInteger = shrinkInteger;